<template>
    <div class="form-narrow">
        <div class="mb-4">
            <label class="form-label">Электронная почта</label>
            <div class="fs-6" id="email">{{ email }}</div>
        </div>

        <div class="mb-4">
            <label class="form-label">Сменить пароль</label>
            <div class="mb-3">
                <input type="password" class="form-control" id="current_password" v-model="current_password" placeholder="Текущий пароль">
            </div>

            <div class="mb-3">
                <input type="password" class="form-control" id="new_password" v-model="new_password" placeholder="Новый пароль">
            </div>

            <div>
                <input type="password" class="form-control" id="repeat_new_password" v-model="repeat_new_password" placeholder="Повторите новый пароль">
            </div>
        </div>

        <div class="mb-4">
            <label class="form-label">Логин</label>
            <input type="text" class="form-control" id="login" v-model="login" placeholder="Логин">
        </div>

        <div class="mb-4">
            <label class="form-label">Номер телефона</label>
            <input type="number" class="form-control" id="phone_number" v-model="phone_number" placeholder="Номер телефона">
        </div>

        <div class="mb-4">
            <label class="form-label">Имя</label>
            <input type="text" class="form-control" id="name" v-model="name" placeholder="Имя">
        </div>

        <div class="mb-4">
            <label class="form-label">Фамилия</label>
            <input type="text" class="form-control" id="surname" v-model="surname" placeholder="Фамилия">
        </div>

        <div class="mb-4">
            <label class="form-label">Отчество</label>
            <input type="text" class="form-control" id="patronymic" v-model="patronymic" placeholder="Отчество">
        </div>

        <div class="mb-4">
            <button class="btn btn-lg btn-light me-3" v-on:click="removeProfile">Удалить аккаунт</button>
        </div>

        <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
            <button class="btn btn-lg btn-primary me-3" v-on:click="editProfile">Сохранить</button>
            <a class="btn btn-lg btn-grey btn-outline-dark" href="/">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import { withPopper } from '../../../utilites.js';
import Profile from '../../../models/Profile';
import Alert from '../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'UserProfileComponent',
    components: { Alert },
    props: {
        route_update: String,
        route_delete: String,
        route_logout: String,
        user: Object
    },
    data: function () {
        return {
            profile: new Profile({
                route_update: this.route_update,
                route_delete: this.route_delete
            }),
            login: '',
            current_password: '',
            new_password: '',
            repeat_new_password: '',
            email: '',
            phone_number: '',
            name: '',
            surname: '',
            patronymic: '',
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        withPopper,
        setUserData: async function() {
            this.login = this.user.login;
            this.email = this.user.email;
            this.phone_number = this.user.mobile_phone === null ? '' : this.user.mobile_phone;
            this.name = this.user.name === null ? '' : this.user.name;
            this.surname = this.user.surname === null ? '' : this.user.surname;
            this.patronymic = this.user.patronymic === null ? '' : this.user.patronymic;
        },
        editProfile: async function() {
            let formData = new FormData();
            formData.append('email', this.email);
            formData.append('current_password', this.current_password);
            formData.append('new_password', this.new_password);
            formData.append('repeat_new_password', this.repeat_new_password);
            formData.append('login', this.login);
            formData.append('mobile_phone', this.phone_number);
            formData.append('name', this.name);
            formData.append('surname', this.surname);
            formData.append('patronymic', this.patronymic);
            formData.append('id', this.user.id);

            let response = await this.profile.update(formData);

            if (response.status == 'error') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.message });
            }

            if (response.status == 'ok') {
                window.location.reload();
            } else {
                console.log('error: update_profile');
            }
        },
        removeProfile: async function () {
            let confirmation = confirm('Вы уверены, что хотите удалить учетную запись?');

            if(!confirmation) {
                return;
            }

            if (confirmation) {
                this.profile.delete(this.user.id).then(this.logout);
            }
        },
        logout: async function () {
            window.location.href = this.route_logout
        },
        showError() {
            this.$refs.Error.showError()
        },
    },
    mounted () {
        this.setUserData();
    }
};
</script>
